import Vue from 'vue';
import { api } from '@/utils/client';
import router from '@/router';

const state = {
	index: {meta: {total: 0, last_page:1, current_page:1}, data:[]},
	menu: [],
	detail: {
		name:'', slug:'', privacy:'', type:'', status:'', page_text:'', page_content:'', options:[],
	},
	optionDetail: {},
	registrations: {meta: {total: 0, last_page:1, current_page:1, invited_count:0, unconfirmed_count:0, confirmed_count:0}, data:[]},
	registrationDetail: {},
	registrationStats: [],
}

// actions
const actions = {
	async fetchGiftBoxCampaigns(context, page = {}) {
		try {
			let response = await api.get('/teams/'+ (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' ? context.rootState.teamId : context.rootState.demo.teamId)  +'/gb-campaigns', {params:page});
			context.commit('fetchGiftBoxCampaigns', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchGiftBoxCampaignsMenu(context, page = {}) {
		try {
			let response = await api.get('/teams/'+ context.rootState.teamId +'/gb-campaigns/menu', {params:page});
			context.commit('fetchGiftBoxCampaignsMenu', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchGiftBoxCampaign(context, {campaignId, params = {}}) {
		try {
			let response = await api.get('/gb-campaigns/' + campaignId, { params });
			context.commit('fetchGiftBoxCampaign', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async createGiftBoxCampaign(context, payload) {
		try {
			let response = await api.post('/teams/'+ (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' ? context.rootState.teamId : context.rootState.demo.teamId) +'/gb-campaigns', payload);
			context.commit('fetchGiftBoxCampaign', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateGiftBoxCampaign(context, {campaignId, payload}) {
		try {
			let response = await api.post('/put/gb-campaigns/' + campaignId, payload);
			context.commit('fetchGiftBoxCampaign', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateGiftBoxCampaignOption(context, {optionId, payload}) {
		try {
			let response = await api.post('/put/gb-options/' + optionId, payload);
			context.commit('fetchGiftBoxCampaignOption', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchGiftBoxOption(context, data) {
		try {
			let response = await api.get('/gb-options/' + data.optionId);
			context.commit('fetchGiftBoxOption', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchGiftBoxRegistrations(context, payload) {
		try {
			let response = await api.get('/teams/' + (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' || (payload && payload.platform == 'marketplace')? context.rootState.teamId : context.rootState.demo.teamId) + '/gb-registrations', {params:payload});
			context.commit('fetchGiftBoxRegistrations', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async exportGiftBoxRegistrations(context, campaignId) {
		try {
			let response = await api.get('/gb-campaigns/' + campaignId + '/registrations/export');
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchCampaignGiftBoxRegistrations(context, payload) {
		try {
			let response = await api.get('/gb-campaigns/' + payload.campaignId + '/registrations?with_reg_counts=true', {params:payload});
			context.commit('fetchGiftBoxRegistrations', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchGiftBoxRegistrationStats(context, payload) {
		try {
			let response = await api.get('/teams/' + (context.rootState.team.detail.plan=='pro' || router.history.current.path=='/dashboard' ? context.rootState.teamId : context.rootState.demo.teamId) + '/gb-registrations/stats', {params:payload});
			context.commit('fetchGiftBoxRegistrationStats', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchBatchDetails(context, data) {
		try {
			let response = await api.get('/gb-campaigns/' + data.campaignId + '/registrations/batch/' + data.sharedSecret);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateBatch(context, {data, payload}) {
		try {
			let response = await api.put('/gb-campaigns/' + data.campaignId + '/registrations/batch/' + data.sharedSecret, payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchGiftBoxRegistration(context, {registrationId}) {
		try {
			let response = await api.get('/gb-registrations/' + registrationId);
			context.commit('fetchGiftBoxRegistration', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async createGiftBoxCampaignRegistration(context, {campaignId, payload}) {
		try {
			let response = await api.post('/gb-campaigns/' + campaignId + '/registrations', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async createGiftBoxRegistration(context, {payload}) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId + '/gb-registrations', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateGiftBoxRegistration(context, {registrationId, payload}) {
		try {
			let response = await api.put('/gb-registrations/' + registrationId, payload);
			context.commit('refreshGiftBoxRegistration', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async multiInviteGiftBoxCampaign(context, {campaignId, emails, notecardType, notecardText, invitationMessage}) {
		try {
			let response = await api.post('/gb-campaigns/' + campaignId + '/registrations/invite/multiple', { emails: emails, notecard_type: notecardType, notecard_text: notecardText, invitation_message: invitationMessage });
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async giftCampaignGenerateLink(context, {campaignId, payload}) {
		try {
			let response = await api.post('/gb-campaigns/' + campaignId + '/registrations/invite/link', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async marketplaceGenerateLink(context, {payload}) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId + '/gb-registrations/invite/link?platform=marketplace', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
    async campaignInviteFromSurvey(context, {campaignId, payload}) {
        try {
            let response = await api.post('/gb-campaigns/' + campaignId + '/registrations/invite/survey', payload);
            return response;
        } catch (e) { console.log(e); throw e; }
    },
	async CSVMultiSend(context, {campaignId, payload}) {
		try {
			let response = await api.post('/gb-campaigns/' + campaignId + '/registrations/bulk/csv', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async CSVMultiLink(context, {campaignId, payload}) {
		try {
			let response = await api.post('/gb-campaigns/' + campaignId + '/registrations/bulk/csv-link', payload);
			return response;
		} catch (e) { console.log(e); throw e; }
	},

}
// mutations
const mutations = {
	fetchGiftBoxCampaigns(state, data) {
		state.index = data;
	},
	fetchGiftBoxCampaignsMenu(state, data) {
		state.menu = data;
	},
	fetchGiftBoxCampaign(state, data) {
		state.detail = data;
	},
	fetchGiftBoxOption(state, data) {
		state.optionDetail = data;
	},
	fetchGiftBoxRegistrations(state, data) {
		state.registrations = data;
		state.registrations.data.forEach(x => {
			x.expected_delivery = x.expected_delivery ? new Date(x.expected_delivery) : x.expected_delivery
		})
	},
	fetchGiftBoxRegistrationStats(state, data) {
		state.registrationStats = data;
	},
	fetchGiftBoxRegistration(state, data) {
		state.registrationDetail = data;
	},
	fetchGiftBoxCampaignOption(state, data) {
		state.optionDetail = data;
	},
	refreshGiftBoxRegistration(state, data) {
		let index = state.registrations.data.findIndex(i => i.id === data.id);
		index > -1 ? Vue.set(state.registrations.data, index, data) : state.registrations.data.push(data);
	},
}

export default {
	state,
	actions,
	mutations
}
